import { render, staticRenderFns } from "./technicalnormDetail.vue?vue&type=template&id=63b04ce0&scoped=true&"
import script from "./technicalnormDetail.vue?vue&type=script&lang=js&"
export * from "./technicalnormDetail.vue?vue&type=script&lang=js&"
import style0 from "./technicalnormDetail.vue?vue&type=style&index=0&id=63b04ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b04ce0",
  null
  
)

export default component.exports